/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMod } from '../../factoriesNumber.js';
export var modDependencies = {
  typedDependencies,
  createMod
};